export const LABOR_REGISTOR_REQUEST = 'LABOR_REGISTOR_REQUEST'
export const NEW_LABOR_SUCCESS = 'NEW_LABOR_SUCCESS'
export const NEW_LABOR_FAIL = 'NEW_LABOR_FAIL'



export const LABOR_DETAILS_REQUEST='LABOR_DETAILS_REQUEST'
export const LABOR_DETAILS_SUCCESS='LABOR_DETAILS_SUCCESS'
export const LABOR_DETAILS_FAIL='LABOR_DETAILS_FAIL'

export const NEW_REVIEW_REQUEST = 'NEW_REVIEW_REQUEST'
export const NEW_REVIEW_SUCCESS = 'NEW_REVIEW_SUCCESS'
export const NEW_REVIEW_RESET = 'NEW_REVIEW_RESET'

export const NEW_REVIEW_FAIL = 'NEW_REVIEW_FAIL'

export const GET_REVIEWS_REQUEST = 'GET_REVIEWS_REQUEST'
export const GET_REVIEWS_SUCCESS = 'GET_REVIEWS_SUCCESS'
export const GET_REVIEWS_FAIL = 'GET_REVIEWS_FAIL'

export const DELETE_LABOR_REQUEST='DELETE_LABOR_REQUEST'
export const DELETE_LABOR_SUCCESS='DELETE_LABOR_SUCCESS,'
export const DELETE_LABOR_FAIL='DELETE_LABOR_FAIL,'
export const DELETE_LABOR_RESET='DELETE_LABOR_RESET'

export const ADMIN_LABOR_REQUEST = 'ADMIN_LABOR_REQUEST'
export const ADMIN_LABOR_SUCCESS = 'ADMIN_LABOR_SUCCESS'
export const ADMIN_LABOR_FAIL = 'ADMIN_LABOR_FAIL'

export const DELETE_REVIEW_REQUEST = 'DELETE_REVIEW_REQUEST'
export const DELETE_REVIEW_SUCCESS = 'DELETE_REVIEW_SUCCESS'
export const DELETE_REVIEW_RESET = 'DELETE_REVIEW_RESET'
export const DELETE_REVIEW_FAIL = 'DELETE_REVIEW_FAIL'

export const CLEAR_ERRORS = 'CLEAR_ERRORS'